import ApplicationAdapter from './application';

export default class ThoughtBubbleFlowInvocationAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
